module.exports = __webpack_public_path__ + "img/81-Bleu Métal X-Brush.jpg";